/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMcpMetadataSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpMetadataSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpMetadataSecurity = {
  option1?: GetMcpMetadataSecurityOption1 | undefined;
  option2?: GetMcpMetadataSecurityOption2 | undefined;
};

export type GetMcpMetadataRequest = {
  /**
   * The slug of the toolset associated with this install page metadata. Mutually exclusive with mcp_server_id.
   */
  toolsetSlug?: string | undefined;
  /**
   * The ID of the MCP server associated with this install page metadata. Mutually exclusive with toolset_slug.
   */
  mcpServerId?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMcpMetadataSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpMetadataSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMcpMetadataSecurityOption1$Outbound,
  GetMcpMetadataSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMcpMetadataSecurityOption1ToJSON(
  getMcpMetadataSecurityOption1: GetMcpMetadataSecurityOption1,
): string {
  return JSON.stringify(
    GetMcpMetadataSecurityOption1$outboundSchema.parse(
      getMcpMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpMetadataSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpMetadataSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMcpMetadataSecurityOption2$Outbound,
  GetMcpMetadataSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMcpMetadataSecurityOption2ToJSON(
  getMcpMetadataSecurityOption2: GetMcpMetadataSecurityOption2,
): string {
  return JSON.stringify(
    GetMcpMetadataSecurityOption2$outboundSchema.parse(
      getMcpMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpMetadataSecurity$Outbound = {
  Option1?: GetMcpMetadataSecurityOption1$Outbound | undefined;
  Option2?: GetMcpMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpMetadataSecurity$outboundSchema: z.ZodMiniType<
  GetMcpMetadataSecurity$Outbound,
  GetMcpMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpMetadataSecurityToJSON(
  getMcpMetadataSecurity: GetMcpMetadataSecurity,
): string {
  return JSON.stringify(
    GetMcpMetadataSecurity$outboundSchema.parse(getMcpMetadataSecurity),
  );
}

/** @internal */
export type GetMcpMetadataRequest$Outbound = {
  toolset_slug?: string | undefined;
  mcp_server_id?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMcpMetadataRequest$outboundSchema: z.ZodMiniType<
  GetMcpMetadataRequest$Outbound,
  GetMcpMetadataRequest
> = z.pipe(
  z.object({
    toolsetSlug: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolsetSlug: "toolset_slug",
      mcpServerId: "mcp_server_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMcpMetadataRequestToJSON(
  getMcpMetadataRequest: GetMcpMetadataRequest,
): string {
  return JSON.stringify(
    GetMcpMetadataRequest$outboundSchema.parse(getMcpMetadataRequest),
  );
}
